export default Object.freeze({
  RegularPresential: 1,
  RegularCybertherapy: 2,
  Absence: 3,
  PresentialRepositionCurrentYear: 4,
  CybertherapyRepositionCurrentYear: 5,
  PresentialRepositionDeLastYear: 6,
  CompensatorioReposicion: 7,
  DiscusionInformeProgreso: 8,
  ParticipacionDeCompu: 9,
  CybertherapyRepositionDeLastYear: 10,
  CompensatorioAusenciaOfrecimiento: 11,
  TelepracticaRegresion: 20,
  PresencialRegresion: 21,
  AusenciaEspecialista: 22,
  TelepracticaReposicion: 23,
  PresencialReposicion: 24,
  AusenciaOfrecimientoRegresion: 25,
  AusenciaOfrecimientoReposicion: 26,
});
